import { ButtonHTMLAttributes, ReactNode } from "react";

interface InlineButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  leftIcon?: ReactNode;
}

export function InlineButton(props: InlineButtonProps) {
  return (
    <button
      type="button"
      {...props}
      className={`rounded-md text-gray-600 flex flex-row justify-center items-center hover:text-gray-400 disabled:text-gray-300 disabled:cursor-not-allowed ${props.className}`}
    >
      {props.leftIcon && <span className="mr-1 mt-1">{props.leftIcon}</span>}
      {props.children}
    </button>
  );
}
